import localisations from "../../localisation";
import { Typography } from "@mui/material";
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import { red } from "@mui/material/colors";

function ImportWarning() {
    return (
        <>            
            <HourglassBottomIcon sx={{ color: red[600], fontSize: 100, textAlign:"center", marginLeft:"auto", marginRight:"auto" }}/>
            <Typography variant="h5" gutterBottom textAlign={"center"}>
                {localisations.importWarning.warningText}
            </Typography>
        </>
    )
}

export default ImportWarning;
